<div *ngIf="componentReady" [formGroup]="inputForm" class="ManagedDeletedAccountDialog d-flex flex-column gap-3">
    <h4>{{ headerText }}</h4>
    <div class="alert alert-warning">
            <p>"Forward to” functionality allows soft-deleted accounts to receive inbound messages from their contacts for a given period. If contact replies, when inbound message reaches Retreva’s servers it will not be declined due to the deleted status of the account. Message will be forwarded to the soft-deleted account with enabled “forward to” setting.
If the account has a notification email set with the checkbox "Set this as the forward email address.", it will be used as forwarding destination. If no explicit email is set in the notification email configuration, the default account’s email address will be the forwarding destination for that message.
Please note, the "Set this as the forward email address." setting should be ON and notification email field should be filled in with valid email address in order to re-route the incoming messages. Otherwise the system will default to user's email account.
Forward period is calculated as date of the action + selected years. You can select either 1 or 2 years. Soft deleted accounts with active forwarding functionality can be found in the Trash menu. Admins can change the forwarding setting of soft deleted accounts"</p>
    </div>

    <mat-checkbox formControlName="deleted_forward" class="DeleteDataCheckbox">
        Enable "Forward to" functionality
    </mat-checkbox>

    <div class="d-flex flex-column" *ngIf="showNotificationPreferences">
        <p *ngIf="account.notification_email">Forwarding email: <span [appCopyText]="true">{{ account.notification_email }}</span></p>

        <mat-checkbox formControlName="change_notification_preferences" class="DeleteDataCheckbox" *ngIf="inputForm.get('deleted_forward').value">
            Manage forwarding  email
        </mat-checkbox>

        <app-text-field class="pt-3" formControlName="email" placeholder="Notification email" *ngIf="inputForm.get('change_notification_preferences').value"></app-text-field>
    </div>

    <p *ngIf="account.forward_to">Forwarding inbound emails until: <span>{{account.forward_to | timezone: 'MM/DD/YYYY'}}</span></p>
    <div class="d-flex flex-row gap-1">
       <div class=flex-grow-1>
        <app-select [items]="periods" formControlName="period" [label]="'Forwarding period'"></app-select>
       </div> 
    </div>
</div>